/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.MarketPricing {
    "use strict";

    import IPagedResultsColumns = Meevo.Components.BaseClasses.IPagedResultsColumns;
    import IPagerModel = Meevo.Plugins.MarketPricing.IPagerModel;
    import FeeTypeEnum = Meevo.Model.FeeTypeEnum;
    import BillingTypeEnum = Meevo.Model.BillingTypeEnum;
    import AutoRenewTypeEnum = Meevo.Model.AutoRenewTypeEnum;

    export class MembershipsSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<IPagerModel> {
        public filter: any;
        public filterCriteria: any = {
            priceGroupId: '',
            serviceCategoryId: undefined,
        };
        public showFilteredItems: boolean = false;
        public isPreviewMassUpdate: boolean = false;
        public serviceCategory: any;
        public membershipType: any;
        public amount: any;
        public feeTypeValue: any;
        public massUpdateCriteria: any = {
            increase: false,
            amount: 0,
            isPercent: false,
            feeType: null,
            isMinFee: false
        };

        private _feesTranslate = [
            {
                id: 0,
                displayName: "LABEL_ENROLLMENT_FEE"
            },
            {
                id: 1,
                displayName: "LABEL_MINIMUM_ENROLLMENT_FEE"
            },
            {
                id: 2,
                displayName: "LABEL_RECURRING_FEE"
            },
            {
                id: 3,
                displayName: "LABEL_MINIMUM_RECURRING_FEE"
            },
            {
                id: 4,
                displayName: "LABEL_RENEWAL_FEE"
            },
            {
                id: 5,
                displayName: "LABEL_MINIMUM_RENEWAL_FEE"
            }
        ];

        private _billingTypeTranslate = [
            {
                id: null,
                displayName: "LABEL_ALL"
            },
            {
                id: BillingTypeEnum.PaidInFull,
                displayName: "LABEL_PAID_IN_FULL"
            },
            {
                id: BillingTypeEnum.RecurringPayments,
                displayName: "LABEL_RECURRING_PAYMENTS"
            }
        ];

        constructor(protected params: Meevo.Model.ISectionParamsMarketPrice) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.identityService,
                params.noun,
                params.appSettings,
                params.sectionSecurityKey
            );
            this['billingTypeEnum'] = Meevo.Model.BillingTypeEnum;
            this['autoRenewTypeEnum'] = Meevo.Model.AutoRenewTypeEnum;
        }

        public defaultCriteria() {
            return this.filterCriteria;
        }

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void {

            this.postCancel();
            this.takeBackup();
        }

        /**
         * When tab is activated
         * */
        public sectionModelRetrieved(): void {
            this.filter = {
                fees: this._feesTranslate,
                billingType: this._billingTypeTranslate,
                sort: [
                    {
                        sortName: 'LABEL_INCREASE',
                        value: true
                    },
                    {
                        sortName: 'LABEL_DECREASE',
                        value: false
                    }
                ]
            };

            this.showFilteredItems = true;

            this.postCancel();
        }

        public translateFee(priceId): string {
            let priceObj = _.find(this._feesTranslate, function (level) {
                return level.id === priceId;
            });

            return priceObj.displayName;
        }

        public prevUnselected(): void {
            this.sectionEndpoint = '';

            super.prevUnselected();
        }

        public changeFeeType(): any {
            switch (this.feeTypeValue) {
                case 0:
                    this.massUpdateCriteria.feeType = FeeTypeEnum.Enrollment;
                    this.massUpdateCriteria.isMinFee = false;
                    break;
                case 1:
                    this.massUpdateCriteria.feeType = FeeTypeEnum.Enrollment;
                    this.massUpdateCriteria.isMinFee = true;
                    break;
                case 2:
                    this.massUpdateCriteria.feeType = FeeTypeEnum.Recurring;
                    this.massUpdateCriteria.isMinFee = false;
                    break;
                case 3:
                    this.massUpdateCriteria.feeType = FeeTypeEnum.Recurring;
                    this.massUpdateCriteria.isMinFee = true;
                    break;
                case 4:
                    this.massUpdateCriteria.feeType = FeeTypeEnum.Renewal;
                    this.massUpdateCriteria.isMinFee = false;
                    break;
                case 5:
                    this.massUpdateCriteria.feeType = FeeTypeEnum.Renewal;
                    this.massUpdateCriteria.isMinFee = true;
                    break;
            }
        }

        /**
         * Save
         * */
        public preSave(): any {
            this.sectionEndpoint = 'membership';

            if (this.isPreviewMassUpdate) {

                // Create object for save Mass update
                this.model = <IPagerModel>{
                    membershipTypeId: this.filterCriteria.membershipTypeId,
                    billingTypeEnum: this.filterCriteria.billingTypeEnum,
                    increase: this.massUpdateCriteria.increase,
                    amount: this.massUpdateCriteria.isPercent ? this.amount * 100 : this.amount,
                    isPercent: this.massUpdateCriteria.isPercent,
                    feeType: this.massUpdateCriteria.feeType,
                    isMinFee: this.massUpdateCriteria.isMinFee
                }
            } else {
                let currentPage = this.model.pages[this.model.currentPage];
                let originalEntity = this.originalEntity;
                let originalCurrentPage = originalEntity.pages[this.model.currentPage];
                let save = {
                    membershipTypeId: this.filterCriteria.membershipTypeId,
                    billingTypeEnum: this.filterCriteria.billingTypeEnum,
                    includeInactive: this.filterCriteria.includeInactive,
                    models: []
                };

                // Find changed items
                _.each(currentPage, (element: any, index) => {
                    let originalElement = originalCurrentPage[index],
                        hasChanged: boolean = false,
                        saveEl: any = {
                            name: element.membershipDisplayName,
                            membershipId: element.membershipId,
                            memberType: element.memberTypeEnum,
                        };

                    if (element.enrollmentFee !== originalElement.enrollmentFee) {
                        saveEl.enrollmentFee = element.enrollmentFee;
                        hasChanged = true;
                    }
                    if (element.minEnrollmentFee !== originalElement.minEnrollmentFee) {
                        saveEl.minEnrollmentFee = element.minEnrollmentFee;
                        hasChanged = true;
                    }
                    if (element.recurringFee !== originalElement.recurringFee) {
                        saveEl.recurringFee = element.recurringFee;
                        hasChanged = true;
                    }
                    if (element.minRecurringFee !== originalElement.minRecurringFee) {
                        saveEl.minRecurringFee = element.minRecurringFee;
                        hasChanged = true;
                    }
                    if (element.monthlyRenewalFee !== originalElement.monthlyRenewalFee) {
                        saveEl.monthlyRenewalFee = element.monthlyRenewalFee;
                        hasChanged = true;
                    }
                    if (element.minMonthlyRenewalFee !== originalElement.minMonthlyRenewalFee) {
                        saveEl.minMonthlyRenewalFee = element.minMonthlyRenewalFee;
                        hasChanged = true;
                    }
                    if (element.pifRenewalFee !== originalElement.pifRenewalFee) {
                        saveEl.pifRenewalFee = element.pifRenewalFee;
                        hasChanged = true;
                    }
                    if (element.minPIFRenewalFee !== originalElement.minPIFRenewalFee) {
                        saveEl.minPIFRenewalFee = element.minPIFRenewalFee;
                        hasChanged = true;
                    }

                    if (hasChanged) {
                        save.models.push(saveEl);
                    }
                });

                this.model = <IPagerModel>save;
            }
        }

        /**
        * Clear data
        * */
        public postCancel(): void {
            this.isPreviewMassUpdate = false;

            this.filterCriteria.priceGroupId = this.parentItemId;
            this.filterCriteria.amount = 0;

            // set select element to default value from ng-selected
            this.massUpdateCriteria.increase = 'unexisting value';

            this.massUpdateCriteria.feeType = FeeTypeEnum.Enrollment;
            this.massUpdateCriteria.isMinFee = false;
            this.feeTypeValue = 0;

            this.amount = 0;
            this.massUpdateCriteria.amount = 0;
            this.massUpdateCriteria.isPercent = false;
        }
    }
}
